import http from "./http";

const getUuid = async (uuid) => {
    return http.get(`/sim_swap//${uuid}/`);
}
const saveAddress = (uuid, lat, lng, building, street, apartment, reference_point, location_auto_detected) => {
    const payload = {
        "url_id": uuid,
        "location": {
            "latitude": lat,
            "longitude": lng
        },
        building: emptyStrToOne(building),
        apartment: emptyStrToOne(apartment),
        street: emptyStrToOne(street),
        reference_point: emptyStrToOne(reference_point),
        location_auto_detected
    }
    return http.patch("/sim_swap/address/", payload);
}
const emptyStrToOne = (value) => {
    return value === "" ? 1 : value;
}

const finalSubmit = (uuid, date, time, location_auto_detected) => {
    const payload = {
        "url_id": uuid,
        "expected_date": date,
        "expected_time": time,
        location_auto_detected
    }
    return http.patch("/sim_swap/submit", payload);
}
const cancel = (uuid) => {
    return http.delete(`/sim_swap/cancel/${uuid}`);
}


export {
    getUuid,
    saveAddress,
    finalSubmit,
    cancel,
};
